class ReadingProgress {
    constructor() {
        this.container = document.querySelector('.js-reading-progress');
        this.contentList = document.querySelectorAll('.js-reading-content');
        this.estimatedReadingTimeContainer = document.querySelector('.js-estimated-reading-time');
    }

    init() {
        if (this.container) {
            this.estimateReadingTime();

            document.addEventListener('scroll', this.calculateScrollProgress, {
                passive: true
            });
        }
    }

    estimateReadingTime = () => {
        if (this.contentList.length > 0 && this.estimatedReadingTimeContainer) {
            let text;
            let words = 0;

            this.contentList.forEach((content => {
                text = content.innerText;
                words += text.trim().split(/\s+/).length;
            }))

            const wpm = 150;
            const estimatedTime = Math.ceil(words / wpm);

            this.estimatedReadingTimeContainer.innerText = estimatedTime.toString();
            this.estimatedReadingTimeContainer.parentElement.classList.remove('is-invisible');
        }
    }

    calculateScrollProgress = () => {
        let docElem = document.documentElement,
            docBody = document.body,
            scrollTop = docElem['scrollTop'] || docBody['scrollTop'],
            scrollBottom = (docElem['scrollHeight'] || docBody['scrollHeight']) - window.innerHeight,
            scrollPercent = scrollTop / scrollBottom * 100 + '%';

        this.container.style.setProperty("--scrollAmount", scrollPercent);
    }
}

export default new ReadingProgress();
